<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="block_1 flex-row">
        <span class="text_1">智能考试系统</span>
        <div class="text-wrapper_1 flex-col"><span class="text_2">200题精选</span></div>
        <div class="text-wrapper_2 flex-col"><span class="text_3">开始考试</span></div>
      </div>
      <div class="block_2 flex-col">
        <div class="group_2 flex-row justify-between">
          <div class="section_1 flex-row">
            <div class="box_1 flex-col">
              <div class="box_2 flex-row">
                <span class="text_4">UI工程师</span>
                <div class="text-wrapper_3 flex-col"><span class="text_5">模拟考试</span></div>
                <div class="text-wrapper_4 flex-col"><span class="text_6">去刷题</span></div>
              </div>
              <img
                class="image_1"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_3 flex-row">
                <span class="text_7">Java工程师</span>
                <div class="text-wrapper_5 flex-col"><span class="text_8">模拟考试</span></div>
                <div class="text-wrapper_6 flex-col"><span class="text_9">去刷题</span></div>
              </div>
              <img
                class="image_2"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_4 flex-row">
                <span class="text_10">前端工程师</span>
                <div class="text-wrapper_7 flex-col"><span class="text_11">模拟考试</span></div>
                <div class="text-wrapper_8 flex-col"><span class="text_12">去刷题</span></div>
              </div>
              <img
                class="image_3"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_5 flex-row">
                <span class="text_13">运营师</span>
                <div class="text-wrapper_9 flex-col"><span class="text_14">模拟考试</span></div>
                <div class="text-wrapper_10 flex-col"><span class="text_15">去刷题</span></div>
              </div>
              <img
                class="image_4"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_6 flex-row">
                <span class="text_16">客服专员</span>
                <div class="text-wrapper_11 flex-col"><span class="text_17">模拟考试</span></div>
                <div class="text-wrapper_12 flex-col"><span class="text_18">去刷题</span></div>
              </div>
              <img
                class="image_5"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_7 flex-row">
                <span class="text_19">人事专员</span>
                <div class="text-wrapper_13 flex-col"><span class="text_20">模拟考试</span></div>
                <div class="text-wrapper_14 flex-col"><span class="text_21">去刷题</span></div>
              </div>
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_8 flex-row">
                <span class="text_22">大数据工程师</span>
                <div class="text-wrapper_15 flex-col"><span class="text_23">模拟考试</span></div>
                <div class="text-wrapper_16 flex-col"><span class="text_24">去刷题</span></div>
              </div>
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_9 flex-row">
                <span class="text_25">golang工程师</span>
                <div class="text-wrapper_17 flex-col"><span class="text_26">模拟考试</span></div>
                <div class="text-wrapper_18 flex-col"><span class="text_27">去刷题</span></div>
              </div>
              <img
                class="image_8"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_10 flex-row">
                <span class="text_28">nodejs工程师</span>
                <div class="text-wrapper_19 flex-col"><span class="text_29">模拟考试</span></div>
                <div class="text-wrapper_20 flex-col"><span class="text_30">去刷题</span></div>
              </div>
              <img
                class="image_9"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_11 flex-row">
                <span class="text_31">php工程师</span>
                <div class="text-wrapper_21 flex-col"><span class="text_32">模拟考试</span></div>
                <div class="text-wrapper_22 flex-col"><span class="text_33">去刷题</span></div>
              </div>
              <img
                class="image_10"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_12 flex-row">
                <span class="text_34">产品经理</span>
                <div class="text-wrapper_23 flex-col"><span class="text_35">模拟考试</span></div>
                <div class="text-wrapper_24 flex-col"><span class="text_36">去刷题</span></div>
              </div>
              <img
                class="image_11"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_13 flex-row">
                <span class="text_37">UI工程师</span>
                <div class="text-wrapper_25 flex-col"><span class="text_38">模拟考试</span></div>
                <div class="text-wrapper_26 flex-col"><span class="text_39">去刷题</span></div>
              </div>
              <img
                class="image_12"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng0113fbb731ceb110cbf166c8cea34d3f5011ac046a23db1c0c5b6e0b6e68fb94.png"
              />
              <div class="box_14 flex-row">
                <span class="text_40">UI工程师</span>
                <div class="text-wrapper_27 flex-col"><span class="text_41">模拟考试</span></div>
                <div class="text-wrapper_28 flex-col"><span class="text_42">去刷题</span></div>
              </div>
            </div>
            <div class="box_15 flex-col"><div class="group_3 flex-col"></div></div>
          </div>
          <div class="section_2 flex-row justify-end">
            <div class="box_16 flex-col">
              <span class="text_43">一、ArrayList和LinkedList的区别？</span>
              <span class="text_44">参考答案：</span>
              <div class="text-wrapper_29 flex-col">
                <span class="text_45">
                  请输入您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案答案您的答案您的答案
                </span>
                <span class="text_46">234/2000</span>
              </div>
              <div class="box_17 flex-row justify-between">
                <div class="text-wrapper_30 flex-col"><span class="text_47">上一题</span></div>
                <div class="text-wrapper_31 flex-col"><span class="text_48">下一题</span></div>
              </div>
            </div>
            <div class="box_18 flex-col"><div class="group_4 flex-col"></div></div>
          </div>
        </div>
        <div class="group_5 flex-row">
          <div class="text-wrapper_32 flex-col">
            <span class="text_49">免费刷题</span>
            <span class="text_50">2000题</span>
          </div>
          <div class="text-wrapper_33 flex-col">
            <span class="text_51">VIP刷题</span>
            <span class="text_52">精选200题</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />